import { lazy } from 'react';

/** Загружает страницу правил кэшбэка */
export const CashbackRulesPageAsync = lazy(() => import('./CashbackRulesPage'));
